export default [
    {
        lat: 50.07,
        lng: 8.97,
    },
    {
        lat: 50.085,
        lng: 8.98,
    },
    {
        lat: 50.105,
        lng: 8.98,
    },
    {
        lat: 50.13,
        lng: 9.01,
    },
    {
        lat: 50.14,
        lng: 9.065,
    },
    {
        lat: 50.135,
        lng: 9.08,
    },
    {
        lat: 50.145,
        lng: 9.09,
    },
    {
        lat: 50.145,
        lng: 9.13,
    },
    {
        lat: 50.135,
        lng: 9.145,
    },
    {
        lat: 50.14,
        lng: 9.15,
    },
    {
        lat: 50.135,
        lng: 9.165,
    },
    {
        lat: 50.155,
        lng: 9.17,
    },
    {
        lat: 50.17,
        lng: 9.215,
    },
    {
        lat: 50.16,
        lng: 9.25,
    },
    {
        lat: 50.165,
        lng: 9.28,
    },
    {
        lat: 50.155,
        lng: 9.305,
    },
    {
        lat: 50.16,
        lng: 9.34,
    },
    {
        lat: 50.15,
        lng: 9.35,
    },
    {
        lat: 50.15,
        lng: 9.385,
    },
    {
        lat: 50.105,
        lng: 9.415,
    },
    {
        lat: 50.115,
        lng: 9.495,
    },
    {
        lat: 50.145,
        lng: 9.485,
    },
    {
        lat: 50.16,
        lng: 9.49,
    },
    {
        lat: 50.165,
        lng: 9.48,
    },
    {
        lat: 50.21,
        lng: 9.485,
    },
    {
        lat: 50.22,
        lng: 9.475,
    },
    {
        lat: 50.25,
        lng: 9.48,
    },
    {
        lat: 50.26,
        lng: 9.49,
    },
    {
        lat: 50.265,
        lng: 9.505,
    },
    {
        lat: 50.255,
        lng: 9.515,
    },
    {
        lat: 50.25,
        lng: 9.545,
    },
    {
        lat: 50.255,
        lng: 9.58,
    },
    {
        lat: 50.245,
        lng: 9.59,
    },
    {
        lat: 50.245,
        lng: 9.615,
    },
    {
        lat: 50.265,
        lng: 9.62,
    },
    {
        lat: 50.29,
        lng: 9.645,
    },
    {
        lat: 50.3,
        lng: 9.695,
    },
    {
        lat: 50.31,
        lng: 9.7,
    },
    {
        lat: 50.32,
        lng: 9.725,
    },
    {
        lat: 50.335,
        lng: 9.725,
    },
    {
        lat: 50.34,
        lng: 9.715,
    },
    {
        lat: 50.365,
        lng: 9.715,
    },
    {
        lat: 50.39,
        lng: 9.735,
    },
    {
        lat: 50.42,
        lng: 9.73,
    },
    {
        lat: 50.445,
        lng: 9.75,
    },
    {
        lat: 50.445,
        lng: 9.81,
    },
    {
        lat: 50.425,
        lng: 9.83,
    },
    {
        lat: 50.42,
        lng: 9.85,
    },
    {
        lat: 50.43,
        lng: 9.865,
    },
    {
        lat: 50.425,
        lng: 9.9,
    },
    {
        lat: 50.445,
        lng: 9.95,
    },
    {
        lat: 50.495,
        lng: 10.015,
    },
    {
        lat: 50.525,
        lng: 10.02,
    },
    {
        lat: 50.535,
        lng: 10.03,
    },
    {
        lat: 50.535,
        lng: 10.045,
    },
    {
        lat: 50.56,
        lng: 10.065,
    },
    {
        lat: 50.56,
        lng: 10.075,
    },
    {
        lat: 50.585,
        lng: 10.1,
    },
    {
        lat: 50.585,
        lng: 10.13,
    },
    {
        lat: 50.57,
        lng: 10.145,
    },
    {
        lat: 50.575,
        lng: 10.21,
    },
    {
        lat: 50.55,
        lng: 10.235,
    },
    {
        lat: 50.55,
        lng: 10.245,
    },
    {
        lat: 50.535,
        lng: 10.25,
    },
    {
        lat: 50.525,
        lng: 10.27,
    },
    {
        lat: 50.51,
        lng: 10.345,
    },
    {
        lat: 50.495,
        lng: 10.36,
    },
    {
        lat: 50.475,
        lng: 10.36,
    },
    {
        lat: 50.445,
        lng: 10.4,
    },
    {
        lat: 50.445,
        lng: 10.415,
    },
    {
        lat: 50.42,
        lng: 10.425,
    },
    {
        lat: 50.425,
        lng: 10.455,
    },
    {
        lat: 50.415,
        lng: 10.47,
    },
    {
        lat: 50.395,
        lng: 10.48,
    },
    {
        lat: 50.395,
        lng: 10.5,
    },
    {
        lat: 50.38,
        lng: 10.51,
    },
    {
        lat: 50.385,
        lng: 10.55,
    },
    {
        lat: 50.365,
        lng: 10.575,
    },
    {
        lat: 50.355,
        lng: 10.575,
    },
    {
        lat: 50.355,
        lng: 10.61,
    },
    {
        lat: 50.345,
        lng: 10.62,
    },
    {
        lat: 50.31,
        lng: 10.615,
    },
    {
        lat: 50.305,
        lng: 10.625,
    },
    {
        lat: 50.245,
        lng: 10.63,
    },
    {
        lat: 50.245,
        lng: 10.695,
    },
    {
        lat: 50.23,
        lng: 10.705,
    },
    {
        lat: 50.25,
        lng: 10.72,
    },
    {
        lat: 50.245,
        lng: 10.765,
    },
    {
        lat: 50.235,
        lng: 10.78,
    },
    {
        lat: 50.22,
        lng: 10.78,
    },
    {
        lat: 50.2,
        lng: 10.8,
    },
    {
        lat: 50.17,
        lng: 10.8,
    },
    {
        lat: 50.17,
        lng: 10.835,
    },
    {
        lat: 50.18,
        lng: 10.85,
    },
    {
        lat: 50.155,
        lng: 10.9,
    },
    {
        lat: 50.13,
        lng: 10.9,
    },
    {
        lat: 50.11,
        lng: 10.88,
    },
    {
        lat: 50.065,
        lng: 10.88,
    },
    {
        lat: 50.055,
        lng: 10.86,
    },
    {
        lat: 50.025,
        lng: 10.845,
    },
    {
        lat: 50.02,
        lng: 10.79,
    },
    {
        lat: 49.95,
        lng: 10.775,
    },
    {
        lat: 49.945,
        lng: 10.76,
    },
    {
        lat: 49.925,
        lng: 10.755,
    },
    {
        lat: 49.91,
        lng: 10.73,
    },
    {
        lat: 49.895,
        lng: 10.725,
    },
    {
        lat: 49.865,
        lng: 10.695,
    },
    {
        lat: 49.86,
        lng: 10.685,
    },
    {
        lat: 49.865,
        lng: 10.66,
    },
    {
        lat: 49.845,
        lng: 10.64,
    },
    {
        lat: 49.835,
        lng: 10.615,
    },
    {
        lat: 49.835,
        lng: 10.59,
    },
    {
        lat: 49.845,
        lng: 10.57,
    },
    {
        lat: 49.84,
        lng: 10.545,
    },
    {
        lat: 49.83,
        lng: 10.545,
    },
    {
        lat: 49.815,
        lng: 10.53,
    },
    {
        lat: 49.815,
        lng: 10.545,
    },
    {
        lat: 49.805,
        lng: 10.555,
    },
    {
        lat: 49.79,
        lng: 10.555,
    },
    {
        lat: 49.79,
        lng: 10.565,
    },
    {
        lat: 49.775,
        lng: 10.575,
    },
    {
        lat: 49.755,
        lng: 10.575,
    },
    {
        lat: 49.735,
        lng: 10.56,
    },
    {
        lat: 49.735,
        lng: 10.515,
    },
    {
        lat: 49.72,
        lng: 10.47,
    },
    {
        lat: 49.725,
        lng: 10.44,
    },
    {
        lat: 49.71,
        lng: 10.43,
    },
    {
        lat: 49.715,
        lng: 10.405,
    },
    {
        lat: 49.71,
        lng: 10.395,
    },
    {
        lat: 49.7,
        lng: 10.405,
    },
    {
        lat: 49.675,
        lng: 10.405,
    },
    {
        lat: 49.665,
        lng: 10.39,
    },
    {
        lat: 49.66,
        lng: 10.4,
    },
    {
        lat: 49.63,
        lng: 10.41,
    },
    {
        lat: 49.615,
        lng: 10.395,
    },
    {
        lat: 49.6,
        lng: 10.35,
    },
    {
        lat: 49.605,
        lng: 10.345,
    },
    {
        lat: 49.6,
        lng: 10.27,
    },
    {
        lat: 49.61,
        lng: 10.22,
    },
    {
        lat: 49.595,
        lng: 10.22,
    },
    {
        lat: 49.58,
        lng: 10.205,
    },
    {
        lat: 49.58,
        lng: 10.19,
    },
    {
        lat: 49.57,
        lng: 10.185,
    },
    {
        lat: 49.575,
        lng: 10.145,
    },
    {
        lat: 49.59,
        lng: 10.14,
    },
    {
        lat: 49.6,
        lng: 10.115,
    },
    {
        lat: 49.585,
        lng: 10.095,
    },
    {
        lat: 49.54,
        lng: 10.105,
    },
    {
        lat: 49.53,
        lng: 10.1,
    },
    {
        lat: 49.525,
        lng: 10.08,
    },
    {
        lat: 49.495,
        lng: 10.07,
    },
    {
        lat: 49.485,
        lng: 10.04,
    },
    {
        lat: 49.465,
        lng: 10.03,
    },
    {
        lat: 49.46,
        lng: 9.98,
    },
    {
        lat: 49.465,
        lng: 9.965,
    },
    {
        lat: 49.46,
        lng: 9.94,
    },
    {
        lat: 49.475,
        lng: 9.9,
    },
    {
        lat: 49.485,
        lng: 9.895,
    },
    {
        lat: 49.54,
        lng: 9.9,
    },
    {
        lat: 49.545,
        lng: 9.89,
    },
    {
        lat: 49.525,
        lng: 9.865,
    },
    {
        lat: 49.525,
        lng: 9.84,
    },
    {
        lat: 49.535,
        lng: 9.805,
    },
    {
        lat: 49.55,
        lng: 9.79,
    },
    {
        lat: 49.565,
        lng: 9.79,
    },
    {
        lat: 49.58,
        lng: 9.82,
    },
    {
        lat: 49.6,
        lng: 9.82,
    },
    {
        lat: 49.615,
        lng: 9.84,
    },
    {
        lat: 49.625,
        lng: 9.84,
    },
    {
        lat: 49.635,
        lng: 9.815,
    },
    {
        lat: 49.66,
        lng: 9.8,
    },
    {
        lat: 49.685,
        lng: 9.81,
    },
    {
        lat: 49.695,
        lng: 9.805,
    },
    {
        lat: 49.7,
        lng: 9.775,
    },
    {
        lat: 49.685,
        lng: 9.77,
    },
    {
        lat: 49.67,
        lng: 9.75,
    },
    {
        lat: 49.67,
        lng: 9.715,
    },
    {
        lat: 49.695,
        lng: 9.7,
    },
    {
        lat: 49.675,
        lng: 9.685,
    },
    {
        lat: 49.665,
        lng: 9.655,
    },
    {
        lat: 49.68,
        lng: 9.615,
    },
    {
        lat: 49.69,
        lng: 9.615,
    },
    {
        lat: 49.695,
        lng: 9.605,
    },
    {
        lat: 49.735,
        lng: 9.605,
    },
    {
        lat: 49.75,
        lng: 9.62,
    },
    {
        lat: 49.765,
        lng: 9.62,
    },
    {
        lat: 49.76,
        lng: 9.59,
    },
    {
        lat: 49.745,
        lng: 9.59,
    },
    {
        lat: 49.725,
        lng: 9.575,
    },
    {
        lat: 49.725,
        lng: 9.55,
    },
    {
        lat: 49.745,
        lng: 9.535,
    },
    {
        lat: 49.74,
        lng: 9.51,
    },
    {
        lat: 49.75,
        lng: 9.505,
    },
    {
        lat: 49.75,
        lng: 9.495,
    },
    {
        lat: 49.765,
        lng: 9.49,
    },
    {
        lat: 49.75,
        lng: 9.47,
    },
    {
        lat: 49.75,
        lng: 9.445,
    },
    {
        lat: 49.765,
        lng: 9.42,
    },
    {
        lat: 49.75,
        lng: 9.4,
    },
    {
        lat: 49.75,
        lng: 9.41,
    },
    {
        lat: 49.72,
        lng: 9.44,
    },
    {
        lat: 49.65,
        lng: 9.44,
    },
    {
        lat: 49.625,
        lng: 9.415,
    },
    {
        lat: 49.625,
        lng: 9.37,
    },
    {
        lat: 49.635,
        lng: 9.365,
    },
    {
        lat: 49.625,
        lng: 9.355,
    },
    {
        lat: 49.63,
        lng: 9.305,
    },
    {
        lat: 49.61,
        lng: 9.305,
    },
    {
        lat: 49.595,
        lng: 9.295,
    },
    {
        lat: 49.595,
        lng: 9.285,
    },
    {
        lat: 49.57,
        lng: 9.265,
    },
    {
        lat: 49.555,
        lng: 9.22,
    },
    {
        lat: 49.56,
        lng: 9.09,
    },
    {
        lat: 49.58,
        lng: 9.075,
    },
    {
        lat: 49.59,
        lng: 9.05,
    },
    {
        lat: 49.625,
        lng: 9.045,
    },
    {
        lat: 49.65,
        lng: 9.075,
    },
    {
        lat: 49.66,
        lng: 9.07,
    },
    {
        lat: 49.71,
        lng: 9.075,
    },
    {
        lat: 49.715,
        lng: 9.1,
    },
    {
        lat: 49.73,
        lng: 9.105,
    },
    {
        lat: 49.735,
        lng: 9.115,
    },
    {
        lat: 49.745,
        lng: 9.09,
    },
    {
        lat: 49.77,
        lng: 9.09,
    },
    {
        lat: 49.775,
        lng: 9.075,
    },
    {
        lat: 49.815,
        lng: 9.06,
    },
    {
        lat: 49.82,
        lng: 9.03,
    },
    {
        lat: 49.84,
        lng: 9.015,
    },
    {
        lat: 49.895,
        lng: 9.015,
    },
    {
        lat: 49.9,
        lng: 9.005,
    },
    {
        lat: 49.93,
        lng: 9.01,
    },
    {
        lat: 49.935,
        lng: 9,
    },
    {
        lat: 49.96,
        lng: 9.005,
    },
    {
        lat: 49.98,
        lng: 8.995,
    },
    {
        lat: 50,
        lng: 8.995,
    },
    {
        lat: 50.01,
        lng: 9.01,
    },
    {
        lat: 50.025,
        lng: 9.01,
    },
    {
        lat: 50.02,
        lng: 8.98,
    },
    {
        lat: 50.035,
        lng: 8.96,
    },
    {
        lat: 50.055,
        lng: 8.955,
    },
    {
        lat: 50.07,
        lng: 8.97,
    },
];
